export enum moduleWorkflowNames {
  SET_DATA = "SET_DATA",
  SET_DATA_COPY_JOURNEY = "SET_DATA_COPY_JOURNEY",
  SET_WORKFLOW_TIP = "SET_WORKFLOW_TIP",
}
